<template>
  <v-dialog :value="show" max-width="500px" @input="$emit('cancel')">
    <v-card>
      <v-card-title v-html="title || $t('Global.Common.askConfirm')" />
      <v-card-text v-html="description" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-html="$t('Global.Action.cancel')" @click="$emit('cancel')" />
        <v-btn text color="error" v-html="btnText || $t('Global.Action.confirm')" @click="$emit('confirm')" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    show: {type: Boolean, required: false, default: false },
    title: { type: String, required: false },
    description: { type: String, required: false },
    btnText: { type: String, required: false }
  }
}
</script>